import styled, { css } from 'styled-components';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { colors } from 'utils/colors';

export const TableWrapper = styled.div``;

export const TTable = styled(Table)`
  border: 1px solid ${colors.verde};
`;

export const THTableHead = styled(TableHead)``;

export const THTableRow = styled(TableRow)``;

export const THTableCell = styled(TableCell)``;

export const TTableBody = styled(TableBody)``;

export const TTableRow = styled(TableRow)`
  &:last-child td,
  &:last-child th {
    border: 0;
  }
  &:nth-child(odd) {
    background-color: ${colors.verde40};
  }
  &:hover {
    background-color: ${colors.verde10} !important;
  }
`;

export const TTableCell = styled(TableCell)<{ link: boolean }>`
  border: none !important;

  ${(props) =>
    props.link &&
    css`
      color: ${colors.verde10} !important;
      cursor: pointer;
    `}

  ${TTableRow}:hover & {
    background-color: ${colors.verde10} !important; // Ensure hover affects all cells equally
    color: white !important;
  }
  ${(props) =>
    props.link &&
    css`
      &&:hover {
        color: ${colors.azul} !important;
        text-decoration: underline;
      }
    `}
`;

export const ContainerWrapperMobile = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 20px;
  margin: 0;
  border: 1px solid ${colors.verde};
  box-sizing: border-box;
`;

export const ContainerTiTle = styled.div`
  width: 50%;
`;

export const ItemTitle = styled.div`
  font-weight: 700;
  padding: 5px 10px;
  display: flex;
  font-size: 12px;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  text-overflow: ellipsis;
  text-align: start;
  color: ${colors.verde};
  &:nth-child(odd) {
    background-color: ${colors.verde40};
  }
  span {
    white-space: nowrap;
    box-sizing: border-box;
    text-overflow: ellipsis;
    text-align: start;
    overflow: hidden;
  }
`;

export const ContainerRow = styled.div`
  width: 50%;
`;

export const ItemRow = styled.div<{ link: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  font-size: 12px;
  padding: 5px 10px;

  &:nth-child(odd) {
    background-color: ${colors.verde40};
  }
  color: ${colors.preto2} !important;
  ${(props) =>
    props.link &&
    css`
      color: ${colors.verde10} !important;
      text-decoration: underline;
      cursor: pointer;
    `}

  span {
    white-space: nowrap;
    box-sizing: border-box;
    text-overflow: ellipsis;
    text-align: start;
    overflow: hidden;
  }
`;

export const ContainerMobile = styled.div`
  max-height: 600px;
  overflow: auto;
`;

export const QuadroColor = styled.div<{ cor: string }>`
  min-height: 24px;
  max-height: 24px;
  width: 24px;
  height: 24px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  background-color: ${(props) => (props.cor ? props.cor : '#ffffff')};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
`;

export const HiddenColumn = css`
  min-width: 20px;
  max-width: 20px;
  width: 20px;
  background-color: #f0f0f0;
  border-right: 1px solid rgba(224, 224, 224, 1);
  overflow: hidden;
  white-space: nowrap;
`;

export const VisibleColumn = css`
  min-width: auto;
  max-width: auto;
  width: auto;
  background-color: inherit;
  border-left: none;
  overflow: visible;
  white-space: nowrap;
`;
